export default "__VITE_ASSET__CgoW4$uT__"